import { styled } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import {
  getCompanyAvatar,
} from "marketplace/companies/_store/companies-redux-slice";
import { companiesApi } from "marketplace/companies/_api/company-api";
import Company from "marketplace/companies/company";
import { useSelector } from "react-redux";

const StyledAvatar = styled(Avatar)<{ disabled?: boolean }>(({ disabled }) => ({
  opacity: disabled ? 0.5 : 1,
}));
const LoadingProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.grey[theme.palette.mode === "light" ? 200 : 700],
  height: "75%",
  width: "75%",
}));

type CompanyAvatarProps = {
  className?: string;
  company?: Company;
  disabled?: boolean;
};

export default function CompanyAvatar(props: Readonly<CompanyAvatarProps>) {
  const { className, company, disabled } = props;

  const base64AvatarData = useSelector(getCompanyAvatar(company?.id ?? null));
  const { isLoading: isLoadingAvatar, error: errorLoadingAvatar } = companiesApi.useGetCompanyAvatarQuery(
    { companyId: company?.id?.value ?? "" },
    { skip: !company?.profile?.avatarId || !!base64AvatarData }
  );

  return (
    <>
      {(base64AvatarData) ? (
        <StyledAvatar
          className={className}
          disabled={disabled}
          src={base64AvatarData}
        >
          {
            !base64AvatarData
            && isLoadingAvatar
            && !errorLoadingAvatar
            && <LoadingProgress disableShrink />
          }
        </StyledAvatar>
      ) : (
        <Avatar className={className} />
      )}
    </>
  );
}
